import React from "react";
import "../../theme/styles.css";
import AppContainer from "../AppContainer";

const PromoScreen = () => {
  return (
    <AppContainer showNav={false} showFooter={false}>
      <h1>Huntington Beach Promotion!</h1>
      <p>Mucky Duck is launching in November 2019 in Huntington Beach!</p>
      <p>
        Customers can order washes & details within Huntington Beach and
        we&apos;ll take $10 off the regular price for the month of November
        2019.
      </p>
      <p>
        Simply order a wash as normal and the discounted price will appear when
        you confirm your order.
      </p>
    </AppContainer>
  );
};

export default PromoScreen;



// WEBPACK FOOTER //
// ./src/screens/general/PromoScreen.js